<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City</label>
                                    <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="dumpYard.cityId" v-on:change="getCityLists($event.target.value)">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dumpYardName)">
                                    <label>Dump Yard Name</label>
                                    <input maxlength="25" type="text" name="dumpYardName" class="form-control" required v-model="dumpYard.dumpYardName" placeholder="Dump Yard Name" pattern="^[^0-9][a-zA-Z0-9 ]{0,25}$" />
                                    <field-messages name="dumpYardName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Dump Yard Name is a required field
                                        </div>
                                        <div slot="pattern">
                                            Alphabets/Numbers/Special Characters are allowed.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group " :class="fieldClassName(formstate.user)">
                                    <label>Assign Manager</label>
                                    <select name="user" class="form-control" v-model="dumpYard.user">
                                        <option value="" disabled>Select Assign Manager</option>

                                        <option v-for="manager in managerss" :value="manager.id">{{ manager.name }}</option>
                                    </select>
                                    <field-messages name="user" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group" :class="fieldClassName(formstate.contactNumber)">
                                    <label>Contact Number</label>
                                    <input type="text" maxlength="10" name="contactNumber" min="1000000000" class="form-control" v-model="dumpYard.contactNumber" placeholder="Contact Number" pattern="[78965][0-9]{9}" />
                                    <field-messages name="contactNumber" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Contact Number is a required field
                                        </div>
                                        <div slot="pattern">Numbers are allowed.</div>
                                    </field-messages>
                                </validate>
                            </div>

                            <!-- <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.dumpYardManagerName)">
                                    <label>Manager Name</label>
                                    <input type="text" name="dumpYardManagerName" class="form-control"  required v-model="dumpYard.dumpYardManagerName" placeholder="Manager Name">
                                    <field-messages name="dumpYardManagerName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Manager Name is a required field</div>
                                    </field-messages>
                                </validate>
                            </div> -->

                            <!-- <div class="col-md-12">
                                <div class="col-md-6" style="padding-left:0px">
                                    <div>
                                        <location @change-event="setIsDisable" />
                                    </div>
                                </div>
                            </div> -->

                            <!-- <div class="col-sm-6">
                                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog" role="document" style="width: 60%">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <label>
                                                    <gmap-autocomplete @place_changed="handleMarkerDrag"></gmap-autocomplete>
                                                    <button @click="handleMarkerDrag">Add</button>
                                                </label>
                                                <br />

                                                <GmapMap :center="center" :zoom="18" map-style-id="roadmap" :options="mapOptions" style="width: 100vmin; height: 50vmin" ref="mapRef" @click="handleMapClick">
                                                    <GmapMarker :position="marker.position" :clickable="true" :draggable="true" @drag="handleMarkerDrag" @click="panToMarker" />
                                                </GmapMap>
                                                <button @click="geolocate">Detect Location</button>

                                                <p>Selected Position: {{ marker.position }}</p>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </vue-form>
                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'dumpYard' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createDumpYard" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateDumpYard" :disabled="
                  !(formstate.$dirty && formstate.$valid)
                " v-if="$route.params && $route.params._id && $route.params._id != '0'">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import store from "../../../store";
import {
    formService,
    eventBus,
    dumpyardService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";
import location from "../gmapLocation/location";

export default {
    name: "dumpYardCreate",
    components: {
        location,
    },
    data() {
        return {
            // marker: {
            //     position: {
            //         lat: 10,
            //         lng: 10
            //     }
            // },
            // center: {
            //     lat: 10,
            //     lng: 10
            // },
            // mapOptions: {
            //     disableDefaultUI: true,
            // },
            isCityDisable: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            dumpYard: {
                user: "",
                cityId: "",
            },
            oldDumpYard: {},
            dumpYardId: [],
            managerss: {},
            googleLocation: {},
            coordinates: [],
            citys: {},
        };
    },
    mounted() {
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName,
                }, ];

                this.dumpYard["cityId"] = _id;
                this.getCityLists(_id);
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getCityLists(value) {
            this.dumpYard["user"] = "";
            this.getManagers(value);
        },

        getManagers(cityId) {
            this.loading = true;
            const params = {
                $embed: ["role"],
            };
            params.$select = ["_id", "firstName", "lastName"];
            params.isActive = true;
            params.cityId = cityId;
            let managerlist = [];
            this.$userRepository
                .list(params)
                .then((res) => {
                    this.loading = false;
                    res.data.docs.forEach((element) => {
                        if (element.role.name === "Dump Yard Manager") {
                            managerlist.push({
                                name: element.firstName + " " + element.lastName,
                                id: element._id,
                            });
                        }
                    });
                    managerlist.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.managerss = managerlist;
                })
                .catch((error) => {
                    this.loading = false;
                    this.$snotify.error("Get manager list failed", "Error!");
                });
        },

        getDumpYard() {
            const params = {
                // $embed: ['user']
            };
            return this.$dumpyardDataRepository
                .find(this.$route.params._id, params)
                .then((response) => {
                    this.dumpYard = response.data;
                    this.oldDumpYard = _.cloneDeep(this.dumpYard);
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        this.dumpYard.dumpYardName
                    );
                    this.getManagers(this.dumpYard.cityId);
                    // let location = {};
                    // location["name"] = this.dumpYard.dumpYardLocation;
                    // location["lat"] = this.dumpYard.geoloc[0];
                    // location["long"] = this.dumpYard.geoloc[1];
                    // eventBus.$emit("getgeoLocation", location);
                })
                .catch((error) => {
                    this.$snotify.error("Get DumpYard failed", "Error!");
                });
        },

        createDumpYard() {
            this.loading = true;

            // this.dumpYard["dumpYardLocation"] = this.googleLocation.name;
            // this.dumpYard["geoloc"] = this.coordinates;
       
            if(this.dumpYard.user == ''){
                delete this.dumpYard.user
            }
            
            return dumpyardService
                .addDumpYard(this.dumpYard)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.dumpYard.dumpYardName} has been added successfully.!`
                    );
                    this.$router.push("/dumpYard");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "contactNumber already exists") {
                        var errorMessage = "Contact Number Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else if (error.data.message == "dumpYardLocation already exists") {
                        var errorMessage = "Dump Yard Location Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("Dump Yard Create Failed.", "Error!");
                    }
                });
        },

        clearChanges() {
            this.dumpYard = _.cloneDeep(this.oldDumpYard);
            this.formstate._reset();
        },
        updateDumpYard() {
            this.loading = true;
            this.dumpYard.dumpYardId = this.$route.params._id;

            // if (this.googleLocation) {
            //     this.dumpYard["dumpYardLocation"] = this.googleLocation.name;
            //     this.dumpYard["geoloc"] = this.coordinates;
            // }

            return dumpyardService
                .updateDumpYard(this.dumpYard, this.oldDumpYard)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldDumpYard = _.cloneDeep(this.dumpYard);
                    this.$snotify.success(
                        `The ${this.dumpYard.dumpYardName} has been updated successfully.`
                    );
                    this.$router.push("/dumpYard");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "contactNumber already exists") {
                        var errorMessage = "Contact Number Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else if (error.data.message == "dumpYardLocation already exists") {
                        var errorMessage = "Dump Yard Location Already Exist!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("Dump Yard Update Failed.", "Error!");
                    }
                });
        },
    },
    created() {
        // eventBus.$on("geoLocation", (location) => {
        //     this.googleLocation = location;
        //     let locationinfo = Object.values(this.googleLocation);
        //     this.coordinates = locationinfo.splice(0, 2);
        // });
        const promises = [];
        this.loading = true;
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getDumpYard());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error("Promise dumpYard failed", "Error!");
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },

};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}
</style>



// WEBPACK FOOTER //
// dumpYardCreate.vue?74e2e0b1